module.exports = __webpack_public_path__ + "img/eye-closed.900952c3.svg";